import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as tracking from 'dibs-tracking';

import styles from './SearchBarRecentlyViewedItems.scss';

export const SearchBarRecentlyViewedItems = props => {
    const [hasFiredImpressions, setHasFiredImpressions] = useState(false);
    const { recentlyViewedItems } = props;

    const trackClick = (item, index) => {
        tracking.trackEvent({
            category: 'promo interaction',
            action: 'recently viewed - global search items clicked',
            label: 'none',
            value: 0,
        });
        tracking.trackEcommerce({
            type: 'productClick',
            actionField: { list: 'recently viewed - global search', itemId: item.itemId },
            products: [
                {
                    id: item.itemId,
                    dimension83: item.contemporaryTrackingString,
                    position: index + 1,
                    brand: item.dealerPk,
                    list: 'recently viewed - global search',
                },
            ],
        });
    };

    useEffect(() => {
        if (!hasFiredImpressions) {
            tracking.trackEcommerce({
                type: 'productImpression',
                actionField: { list: 'recently viewed - global search' },
                products: recentlyViewedItems.map((item, index) => ({
                    id: item.itemId,
                    dimension83: item.contemporaryTrackingString,
                    position: index + 1,
                    brand: item.dealerPk,
                    list: 'recently viewed - global search',
                })),
            });
            setHasFiredImpressions(true);
        }
    }, [recentlyViewedItems, hasFiredImpressions, setHasFiredImpressions]);

    return (
        <div className={styles.items}>
            {recentlyViewedItems.map((item, index) => (
                <a
                    key={item.itemPdpUrl}
                    className={styles.item}
                    href={item.itemPdpUrl}
                    onClick={() => trackClick(item, index)}
                >
                    <img className={styles.image} src={item.itemImageUrl} />
                </a>
            ))}
        </div>
    );
};

SearchBarRecentlyViewedItems.propTypes = {
    recentlyViewedItems: PropTypes.array,
};
